import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a38a9278&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a38a9278&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=a38a9278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38a9278",
  null
  
)

export default component.exports